<template>
  <el-dialog
    :title="$t('businessReceiptList.btnList.createLogistics')"
    :visible.sync="dialogVisible"
    width="1200px"
    @close="closeDialog"
  >
    <div class="procurement">
      <!-- 表格 -->
      <div class="main-content">
        <vxe-grid
          border
          show-overflow
          resizable
          ref="table"
          class="vxe-table-element"
          size="mini"
          align="left"
          max-height="400px"
          :auto-resize="true"
          :checkbox-config="{ checkAll: true }"
          :data="tableData"
          :columns="columnList"
          :edit-config="{ trigger: 'click', mode: 'row' }"
          column-min-width="120"
        >
        </vxe-grid>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">{{ $t('dialog.cancel') }}</el-button>
        <el-button type="primary" @click="confirm">{{ $t('dialog.confirm') }}</el-button>
      </div>
      <!-- <vxe-toolbar>
        <template v-slot:buttons>
          <vxe-button
            @click="confirm()"
            type="primary"
            size="medium"
            icon="el-icon-plus"
            class="vxe-btn-primary"
            >确认</vxe-button
          >
        </template>
      </vxe-toolbar> -->
    </div>
  </el-dialog>
</template>
<script>
  // import COMPANY_API from '@/api/masterData/company';
  import BUSINESS_API from '@/api/logisticsCenter/businessReceipt';
  // import SiruiSearch from '@/components/SiruiSearch';
  import { filterEmpty } from '@/common/js/util';
  export default {
    components: {
      // SiruiSearch,
    },
    computed: {
      columnList() {
        return [
          { type: 'checkbox', width: 50, checked: true, fixed: 'left' }, // checkbox
          {
            prop: 'inboundNo',
            label: this.$t('businessReceiptList.search.logisticsReceipt'),
            width: 120,
            fixed: 'left',
          },
          {
            prop: 'shippingInstructionNo',
            label: this.$t('businessReceiptList.search.SupplierDelivery'),
            width: 120,
            fixed: 'left',
          },
          {
            prop: 'purchaseContractNo',
            label: this.$t('businessReceiptList.search.purchaseContract'),
            width: 120,
            fixed: 'left',
          },
          {
            prop: 'externalContractNo',
            label: this.$t('businessReceiptList.create.externalContractNo'),
            width: 120,
          },
          {
            prop: 'partnerName',
            label: this.$t('businessReceiptList.search.supplier'),
            width: 100,
          },
          {
            prop: 'productName',
            label: this.$t('businessReceiptList.table.commodityDescription'),
            width: 120,
          },
          {
            prop: 'inboundQuantity',
            label: this.$t('businessReceiptList.create.distributionInboundQuantity'),
            width: 140,
          },
          {
            prop: 'remainingBusinessInboundQuantity',
            label: this.$t('businessReceiptList.create.remainInboundQuantity'),
            width: 140,
          },
          { prop: 'unitNumber', label: this.$t('businessReceiptList.create.number'), width: 100 },
          {
            prop: 'inboundDate',
            label: this.$t('businessReceiptList.create.inboundDate'),
            width: 100,
          },
          {
            prop: 'storageName',
            label: this.$t('businessReceiptList.search.warehouse'),
            width: 100,
          },
          {
            prop: 'businessPropertyName',
            label: this.$t('businessReceiptList.create.managementWay'),
            width: 100,
          },
          {
            prop: 'salesmanName',
            label: this.$t('businessReceiptList.create.personName'),
            width: 100,
          },
          {
            prop: 'inboundCreatePersonName',
            label: this.$t('businessReceiptList.search.makingPeople'),
            width: 100,
          },
          {
            prop: 'inboundDepartmentName',
            label: this.$t('businessReceiptList.search.department'),
            width: 120,
          },
          { prop: 'companyName', label: this.$t('businessReceiptList.search.company'), width: 100 },
          { prop: 'createDate', label: this.$t('businessReceiptList.create.makeTime'), width: 100 },
        ];
      },
    },
    data() {
      return {
        dialogVisible: false,
        ladingVisible: false,
        checkAll: [],
        tableData: [],
      };
    },
    /**页面必要代码Start */
    mounted() {},
    methods: {
      // 弹窗打开时加载界面数据
      openDialog(params) {
        this.dialogVisible = true;
        this.getData(params);
      },
      closeDialog() {
        // 弹窗关闭
        this.dialogVisible = false;
      },
      //获取入库明细数据数据
      getData(params) {
        let extraData = {
          upstreamType: 1,
          inboundStatus: '02',
          isGetRemaind: 1,
          shippingInstructionNo: params.shipNo,
        };
        this.$axios
          .post(BUSINESS_API.LIST_DISTRIBUTION_INBOUND_DIALOG, filterEmpty(extraData))
          .then((res) => {
            this.load = false;
            if (0 == res.data.code) {
              this.tableData = res.data.data.list || [];
            } else {
              this.tableData = [];
              this.$alert(res.data.msg);
            }
          });
      },
      // 确认
      confirm() {
        let selections = this.$refs.table.getCheckboxRecords();
        if (selections.length) {
          const shippingInstructionNo = selections[0].shippingInstructionNo;
          let inboundNoList = [];
          let purchaseContractNoList = [];
          selections.forEach((item) => {
            if (inboundNoList.indexOf(item.inboundNo) < 0) {
              inboundNoList.push(item.inboundNo);
            }
            if (purchaseContractNoList.indexOf(item.purchaseContractNo) < 0) {
              purchaseContractNoList.push(item.purchaseContractNo);
            }
          });
          const inboundNo = inboundNoList.join(',');
          const purchaseContractNo = purchaseContractNoList.join(',');
          // 进入业务入库单创建
          let path = {
            path: '/logistics/businessReceiptAdd',
            name: 'businessReceiptAdd',
            meta: {
              keepAlive: true,
              title: this.$t('businessReceiptList.create.tagTitle'),
            },
            query: {
              inboundNoList: inboundNo, // 物流入库单号，多个填充到一个框里
              shipNo: shippingInstructionNo, // 供应商发货指令号
              contractNo: purchaseContractNo, // 合同号
              sourceType: '2',
            },
          };
          this.$store.dispatch('tagsView/addTabView', path).then(() => {
            this.$nextTick(() => {
              this.$router.push(path);
            });
          });
          this.closeDialog();
        } else {
          // 未勾选
          this.$message({
            showClose: true,
            message: this.$t('businessReceiptList.errorTips.inboundNoEmpty'),
            type: 'error',
          });
        }
      },
    },
  };
</script>
